
export const SET_SELECTED_CLAIM_TYPE = "SET_SELECTED_CLAIM_TYPE";
export const SET_SELECTED_CLAIM_SUB_TYPE = "SET_SELECTED_CLAIM_SUB_TYPE";
export const SET_IN_CLAIM_SUMMARY_PAGE = "SET_IN_CLAIM_SUMMARY_PAGE";
export const SET_MONTH = "SET_MONTH";
export const SET_SEARCH_TEXT = "SET_SEARCH_TEXT";
export const SET_CLAIM_SUMMARY_ROWS = "SET_CLAIM_SUMMARY_ROWS,";
export const SET_CLAIM_IDS_CHECKBOX_HIDDEN = "SET_CLAIM_IDS_CHECKBOX_HIDDEN";
export const SET_CHECKED_CLAIM_IDS = "SET_CHECKED_CLAIM_IDS";
export const SET_OPEN = "SET_OPEN";
export const SET_SELECTED_ROW_TO_EDIT = "SET_SELECTED_ROW_TO_EDIT";
export const SET_SALE_RETURNS_ROWS = "SET_SALE_RETURNS_ROWS";
export const SET_INITIAL_SALE_RETURNS_ROWS = "SET_INITIAL_SALE_RETURNS_ROWS";
export const SET_DISABLE_EDITING = "SET_DISABLE_EDITING";

export const SET_ADD_RETURN_MODAL_VISIBLE = "SET_ADD_RETURN_MODAL_VISIBLE";
export const SET_RETURN_PRODUCTS_ARRAY = "SET_RETURN_PRODUCTS_ARRAY";
export const SET_RETURN_PRODUCT_OBJECT = "SET_RETURN_PRODUCT_OBJECT";
export const SET_BATCH_IDS_EXPANDED = "SET_BATCH_IDS_EXPANDED";
export const SET_CHECKED_BATCHES = "SET_CHECKED_BATCHES";

export const SET_APPROVAL_MODAL_OPEN = "SET_APPROVAL_MODAL_OPEN";
export const SET_APPROVAL_MODAL_STATE = "SET_APPROVAL_MODAL_STATE";
export const SET_SELECTED_RETURN_PRODUCT_ARRAY_IDX =
  "SET_SELECTED_RETURN_PRODUCT_ARRAY_IDX";
export const SET_RETURN_PRODUCT_OBJECT_INITIAL =
  "SET_RETURN_PRODUCT_OBJECT_INITIAL";
export const SET_RETURN_PRODUCT_OBJECT_ORIGINAL =
  "SET_RETURN_PRODUCT_OBJECT_ORIGINAL";
export const SET_EDITED_BATCHES = "SET_EDITED_BATCHES";
export const SET_INITIAL_SECONDARY_SCHEMES_ROW = "SET_INITIAL_SECONDARY_SCHEMES_ROW";
export const SET_SECONDARY_SCHEMES_ROW = "SET_SECONDARY_SCHEMES_ROW";
export const SET_SELECTED_SECONDARY_SCHEMES_ROW ="SET_SELECTED_SECONDARY_SCHEMES_ROW";
export const SET_SELECTED_INVOICE_ROW ="SET_SELECTED_INVOICE_ROW";
export const SET_TOTAL_ORDER_VALUE_ROW = "SET_TOTAL_ORDER_VALUE_ROW";
export const SET_SELECTED_TOTAL_ORDER_VALUE_ROW = "SET_SELECTED_TOTAL_ORDER_VALUE_ROW";
export const RESET_CLAIMS_STATE = "RESET_CLAIMS_STATE";
export const SET_DISCOUNT_MODAL_STATE = "SET_DISCOUNT_MODAL_STATE";
export const SET_SECONDARY_SCHEMES_CHECKED_CLAIM_IDS="SET_SECONDARY_SCHEMES_CHECKED_CLAIM_IDS";
export const SET_TOTAL_ORDER_VALUE_CHECKED_CLAIM_IDS="SET_TOTAL_ORDER_VALUE_CHECKED_CLAIM_IDS";
export const SET_OPEN_CLAIMS_ROWS = "SET_OPEN_CLAIMS_ROWS";
export const SET_SELECTED_OPEN_CLAIMS_ROW = "SET_SELECTED_OPEN_CLAIMS_ROW";
export const SET_VIEW_CLAIMS_ROWS = "SET_VIEW_CLAIMS_ROWS";
export const SET_SELECTED_VIEW_CLAIMS_ROW = "SET_SELECTED_VIEW_CLAIMS_ROW";
export const SET_NON_ELIGIBLE = "SET_NON_ELIGIBLE";
export const SET_CLAIM_START_DATE = "SET_CLAIM_START_DATE";
export const SET_CLAIM_END_DATE = "SET_CLAIM_END_DATE";
